// extracted by mini-css-extract-plugin
module.exports = {"custom__toggle__input":"customToggle_custom__toggle__input__3dTK6"};